import React, { createContext, useContext, useState } from 'react';
import { useDataBoxEvents } from '@gov-nx/core/events';
import type { Nullable } from '@gov-nx/core/types';
import { useDataBoxStore } from '@gov-nx/store';
import type { DataBoxActionInfoContextType } from './ActionInfoContext.types';
import type { DataBoxFolderType } from './DataBoxes.types';
import { DataBoxListStatesType } from './MessageListContext.types';

export const DataBoxActionInfoContext =
	createContext<Nullable<DataBoxActionInfoContextType>>(null);

interface DataBoxActionInfoProviderProps {
	folderType: DataBoxFolderType;
	dataBoxId: string;
	children: React.ReactNode;
}

export function DataBoxActionInfoProvider({
	folderType,
	dataBoxId,
	children,
}: DataBoxActionInfoProviderProps) {
	const dataBoxes = useDataBoxStore('list');

	const [listState, setListState] = useState(DataBoxListStatesType.List);
	const [emptyFolder, setEmptyFolder] = useState(true);

	useDataBoxEvents({
		onListStateChange: (_, { variant, isEmptyFolder }) => {
			setListState(variant);
			setEmptyFolder(isEmptyFolder);
		},
	});

	return (
		<DataBoxActionInfoContext.Provider
			value={{
				listState,
				folderType,
				emptyFolder,
				dataBox: dataBoxes.find(
					(dataBox) => dataBox.datovaSchrankaId === dataBoxId
				),
			}}>
			{children}
		</DataBoxActionInfoContext.Provider>
	);
}

export const useDataBoxActionInfoContext = (): DataBoxActionInfoContextType =>
	useContext(DataBoxActionInfoContext) as DataBoxActionInfoContextType;
